import { useEffect, useState, memo } from "react";

import { Button } from "primereact/button";
import { Chart } from "primereact/chart";

import ChartDataLabels from 'chartjs-plugin-datalabels';
import GraficoResiduoProduto from "../GraficoResiduoProduto";

export const RevisaoGraficoResiduos = memo(function RevisaoGraficoResiduos({ month, months, residuos, residuosProduto, setor }) {
    const [chartData, setChartData] = useState({});
    const [col, setCol] = useState("p-col-12");

    const options = {
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                anchor: 'end',
                align: 'end',
                formatter: (value) => {
                    return Intl.NumberFormat("pt-BR", {
                        maximumFractionDigits: 2,
                    }).format(value);
                },
                font: {
                    size: 14,
                    weight: 'bold',
                },
                color: "#2c3e50"
            },
        },
    }

    useEffect(() => {
        let filteredData = residuos.filter((element) => {
            return element.setor === setor;
        });

        let values = [];

        months.forEach((month, index) => {
            let search = filteredData.find((element) => {
                return parseInt(element.mes) === index + 1;
            });

            if (search) {
                values.push(search.soma);
            } else {
                values.push(0);
            }
        });

        const _chartData = {
            labels: months,
            datasets: [
                {
                    label: 'Total de Resíduos (KG)',
                    data: values,
                    backgroundColor: "#2ecc71"
                }
            ]
        }

        setChartData(_chartData);
    }, [months, residuos, setor])

    return (
        <div>
            <div className="p-grid">
                <div className={col}>
                    <Button
                        icon="pi pi-search"
                        onClick={() => setCol(col === "p-col-6" ? "p-col-12" : "p-col-6")}
                    />
                    {setor !== null && (
                        <Chart
                            data={chartData}
                            height="350px"
                            options={options}
                            plugins={[ChartDataLabels]}
                            type="bar"
                        />
                    )}
                </div>
                
            </div>
            <div className="p-grid">
                <GraficoResiduoProduto
                    month={month}
                    residuos={residuosProduto}
                    setor={setor}
                />
            </div>
        </div>
    )
});